const stateStorageKey = "danroviConnectionState";
const completionURL =
  process.env.REACT_APP_DANROVI_PROVIDER_SESSION_COMPLETE_URL ||
  "https://api.danrovi.com/provider-connections/provider-session/complete";

export const rememberDanroviConnection = (search) => {
  const state = new URLSearchParams(search).get("danrovi_state");
  if (state) {
    window.sessionStorage.setItem(stateStorageKey, state);
  }
};

export const completeDanroviConnection = (token) => {
  const state = window.sessionStorage.getItem(stateStorageKey);
  if (!state || !token) {
    return false;
  }

  window.sessionStorage.removeItem(stateStorageKey);

  const form = document.createElement("form");
  form.method = "post";
  form.action = completionURL;
  form.style.display = "none";

  Object.entries({ state, token }).forEach(([name, value]) => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();
  return true;
};
